const API_URL = '/api/applications';

export const applyForOpportunity = async (data, token) => {
    const response = await fetch(`${API_URL}/apply`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Failed to apply');
    }

    return response.json();
};

export const getMyApplications = async (token) => {
    const response = await fetch(`${API_URL}/my-applications`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Failed to fetch applications');
    }

    return response.json();
};
